import gsap, { TweenMax, TimelineMax, Linear } from 'gsap';
// @ts-ignore-next
import * as ScrollMagic from 'scrollmagic';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

(function ($) {
	// --------- Variables for animations
	var controller = new ScrollMagic.Controller(),
		sectionID,
		interval = 200,
		announcementBar = $('.m-announcement'),
		announcementBarDot1 = $('.m-a-dot1'),
		announcementBarDot2 = $('.m-a-dot2'),
		announcementBarDot3 = $('.m-a-dot3'),
		announcementBarDot3 = $('.m-a-dot3'),
		dotAnimation = $('.mfiDotAnimation'),
		featResources = $('.m-featured-resources'),
		featResourcesImg = $('.mfr-image'),
		animatedImage = $('.animated-image'),
		animatedImageDiv = $('.animated-image-parallax'),
		animationTrigger = $('.animation-trigger');
	// END ---------

	// --------- FN for visibility (checks when element in viewport)
	// @ts-ignore-next
	$.fn.visible = function (partial) {
		var $t = $(this),
			$w = $(window),
			viewTop = $w.scrollTop(),
			// @ts-ignore-next
			viewBottom = viewTop + $w.height(),
			// @ts-ignore-next
			_top = $t.offset().top,
			// @ts-ignore-next
			_bottom = _top + $t.height(),
			compareTop = partial === true ? _bottom : _top,
			compareBottom = partial === true ? _top : _bottom;

		// @ts-ignore-next
		return compareBottom <= viewBottom && compareTop >= viewTop;
	};
	// END ---------

	// ------------------- GSAP -------------------
	// --------- Announcments Section
	if (announcementBar.length > 0 && announcementBarDot1.length > 0) {
		var dot1Tween = gsap.from(announcementBarDot1, 1, {
			delay: 1.15,
			autoAlpha: 0,
		});

		new ScrollMagic.Scene({
			triggerElement: '.m-announcement',
			offset: -window.innerHeight / 2,
			reverse: !0,
		})
			// @ts-ignore-next
			.setTween(dot1Tween)
			.addTo(controller);
	}

	if (announcementBar.length > 0 && announcementBarDot2.length > 0) {
		var dot2Tween = gsap.from(announcementBarDot2, 1, {
			delay: 1.3,
			autoAlpha: 0,
		});

		new ScrollMagic.Scene({
			triggerElement: '.m-announcement',
			offset: -window.innerHeight / 2,
			reverse: !0,
		})
			// @ts-ignore-next
			.setTween(dot2Tween)
			.addTo(controller);
	}
	if (announcementBar.length > 0 && announcementBarDot3.length > 0) {
		var dot3Tween = gsap.from(announcementBarDot3, 1, {
			delay: 1.45,
			autoAlpha: 0,
		});

		new ScrollMagic.Scene({
			triggerElement: '.m-announcement',
			offset: -window.innerHeight / 2,
			reverse: !0,
		})
			// @ts-ignore-next
			.setTween(dot3Tween)
			.addTo(controller);
	}
	// END ---------

	// --------- Integrations Section
	if (dotAnimation.length) {
		dotAnimation.each(function () {
			var section = $(this)[0],
				integrationsDot1 = $(this).find('.mfiDot1'),
				integrationsDot2 = $(this).find('.mfiDot2'),
				integrationsDot3 = $(this).find('.mfiDot3'),
				mfiDot1Tween = gsap.from(integrationsDot1, 1, {
					delay: 0.3,
					autoAlpha: 0,
				}),
				mfiDot2Tween = gsap.from(integrationsDot2, 1, {
					delay: 0.45,
					autoAlpha: 0,
				}),
				mfiDot3Tween = gsap.from(integrationsDot3, 1, {
					delay: 0.6,
					autoAlpha: 0,
				});

			new ScrollMagic.Scene({
				triggerElement: section,
				offset: -window.innerHeight / 2,
				reverse: !0,
			})
				// @ts-ignore-next
				.setTween(mfiDot1Tween)
				.addTo(controller);

			new ScrollMagic.Scene({
				triggerElement: section,
				offset: -window.innerHeight / 2,
				reverse: !0,
			})
				// @ts-ignore-next
				.setTween(mfiDot2Tween)
				.addTo(controller);

			new ScrollMagic.Scene({
				triggerElement: section,
				offset: -window.innerHeight / 2,
				reverse: !0,
			})
				// @ts-ignore-next
				.setTween(mfiDot3Tween)
				.addTo(controller);
		});
	}
	// END ---------

	// --------- Featured Resources Section
	if (featResources.length > 0 && featResourcesImg.length > 0) {
		var mfrTween = gsap.from(featResourcesImg, 1, {
			delay: 0.5,
			y: 150,
		});

		new ScrollMagic.Scene({
			triggerElement: '.m-featured-resources',
			offset: -window.innerHeight / 2,
			reverse: !0,
		})
			// @ts-ignore-next
			.setTween(mfrTween)
			.addTo(controller);
	}
	// END ---------

	// --------- Parralax Image Animation
	if (animatedImage.length > 0 && animatedImageDiv.length > 0) {
		animatedImage.each(function () {
			sectionID = $(this).attr('data-section');
			var blockImgParallax = gsap.fromTo(
				'.animated-image-parallax-' + sectionID,
				1.5,
				{
					y: interval ? '+=' + interval : '+=200',
				},
				{
					y: interval ? '-=' + 2 * interval : '-=200',
					force3D: !1,
					ease: 'none',
				}
			);

			new ScrollMagic.Scene({
				duration: 2 * window.innerHeight,
				triggerElement: '.section--ID' + sectionID,
				offset: -window.innerHeight / 2,
				reverse: !0,
			})
				// @ts-ignore-next
				.setTween(blockImgParallax)
				.addTo(controller);
		});
	}

	if (animationTrigger.length > 0) {
		animationTrigger.each(function () {
			new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: 1,
				offset: 0,
				reverse: false,
			})
				.setClassToggle(this, 'is-animated')
				.addTo(controller);

			$(this)
				.find('.animation-sequence:not(.animation-sequence-parent)')
				.each(function (index) {
					$(this).css({ 'transition-delay': index * 250 + 'ms' });
				});

			$(this)
				.find('.animation-sequence-parent > *:not(br)')
				.each(function (index) {
					$(this).css({ 'transition-delay': index * 250 + 'ms' });
				});
		});
	}
})(jQuery);
